import React, { useEffect, useState } from 'react';
import { Container } from "react-bootstrap";
import { VisualizadorImagenes } from "./VisualizadorImagenes";
import { obtenerArchivos } from "../AccionesBackend";
import {BotonRegresar} from "../BotonRegresar";

export const MaterialApoyo = () => {
    const [materialApoyo, setMaterialApoyo] = useState([]);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchMaterialApoyo = async () => {
            try {
                const response = await obtenerArchivos({ seccionId: 29 });
                if (response && response.success) {
                    if (response.archivos && response.archivos.length > 0) {
                        // Transformamos los archivos recibidos al formato que utiliza VisualizadorImagenes.
                        const mappedMaterialApoyo = response.archivos.map(file => {
                            const parts = file.nombre_completo.split("_");
                            let displayTitle = file.nombre_archivo; // Valor por defecto en caso de no cumplir el formato esperado
                            if (parts.length >= 3) {
                                const timestamp = parseInt(parts[1], 10);
                                // Convertir el timestamp (en segundos) a milisegundos
                                const date = new Date(timestamp * 1000);
                                // Nombres de los meses en español
                                const monthNames = [
                                    "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
                                    "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
                                ];
                                const month = monthNames[date.getMonth()];
                                const year = date.getFullYear();

                                displayTitle = `${month} ${year}`;
                            }
                            return {
                                src: file.ruta_archivo,
                                title: displayTitle,
                                fileName: file.nombre_archivo,
                                seccionId: 29 // En `MaterialApoyo`
                            };
                        });
                        setMaterialApoyo(mappedMaterialApoyo);
                    } else {
                        setError("No se encontró material de apoyo.");
                    }
                } else {
                    setError("Error al obtener el material de apoyo.");
                    console.error("No se pudo obtener el material de apoyo.");
                }
            } catch (err) {
                setError("Error en la conexión o en el servidor.");
                console.error("Error al obtener el material de apoyo:", err);
            }
        };

        fetchMaterialApoyo();
    }, []);

    return (
        <section className="flyers-digitales">
            <Container>
                <div className="banner-lineamientos">
                    <BotonRegresar/>
                    <h1>Material de apoyo</h1>
                </div>
                { error ? (
                    <p style={{ textAlign: "center", padding: "20px", color: "red" }}>{error}</p>
                ) : (
                    <VisualizadorImagenes initialImages={materialApoyo} />
                )}
            </Container>
        </section>
    );
};
